import React from "react";

function ManageUser() {
  return (
    <div>
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-md-10 onboarding-screen">
            <div className="row">
              <div className="col-xl-12">
                <div className="row">
                  <div className="col-xl-12">
                    <div className="remain-option mt-0">
                      <h2>Manage Employee</h2>
                      <div className="row justify-content-center">
                        <div className="col-xl-12">
                          <div className="addcourseform mt-4">
                            <form>
                              <div className="row g-2">
                                <div className="col-md-4">
                                  <label className="form-label">
                                    First Name
                                  </label>
                                  <div className="cover-form">
                                    <div>
                                      <i
                                        className="fa fa-user-o"
                                        aria-hidden="true"
                                      ></i>
                                    </div>
                                    <input
                                      type="text"
                                      className="form-control"
                                      fdprocessedid="l6x5h5"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <label className="form-label">
                                    Last Name
                                  </label>
                                  <div className="cover-form">
                                    <div>
                                      <i
                                        className="fa fa-user-o"
                                        aria-hidden="true"
                                      ></i>
                                    </div>
                                    <input
                                      type="text"
                                      className="form-control"
                                      fdprocessedid="m7yoge"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <label className="form-label">
                                    Organization Email Id
                                  </label>
                                  <div className="cover-form">
                                    <div>
                                      <i
                                        className="fa fa-user-o"
                                        aria-hidden="true"
                                      ></i>
                                    </div>
                                    <input
                                      type="text"
                                      className="form-control"
                                      fdprocessedid="01nv1f"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-1 d-flex align-items-center">
                                  <div className="btns-grp-css">
                                    <button
                                      type="submit"
                                      className="savebtn-click"
                                      fdprocessedid="r9lqa"
                                    >
                                      Add
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                        <div className="col-xl-12 mt-4">
                          <div className="added-employee-card tile-grid tile-grid-v1">
                            <div className="table-responsive card">
                              <table
                                id="example"
                                className="table table-striped table-bordered"
                                style={{ width: "100%" }}
                              >
                                <thead>
                                  <tr>
                                    <th></th>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>Organization Email Id</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <span className="name">SR</span>{" "}
                                    </td>
                                    <td>
                                      <a href="">Savita</a>
                                    </td>
                                    <td>Rana</td>
                                    <td>Savitarana@bizbrolly.com</td>
                                    <td>
                                      <div className="d-flex">
                                        <a className="btn btn-secondary shadow btn-xs sharp me-1">
                                          <i className="fa fa-pencil"></i>
                                        </a>
                                        <a className="btn btn-danger shadow btn-xs sharp me-1">
                                          <i className="fa fa-trash"></i>
                                        </a>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <span className="name">KS</span>{" "}
                                    </td>
                                    <td>
                                      <a href="">Karan</a>
                                    </td>
                                    <td>Singh</td>
                                    <td>karan@bizbrolly.com</td>
                                    <td>
                                      <div className="d-flex">
                                        <a className="btn btn-secondary shadow btn-xs sharp me-1">
                                          <i className="fa fa-pencil"></i>
                                        </a>
                                        <a className="btn btn-danger shadow btn-xs sharp me-1">
                                          <i className="fa fa-trash"></i>
                                        </a>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <span className="name">KK</span>{" "}
                                    </td>
                                    <td>
                                      <a href="">Kavita</a>
                                    </td>
                                    <td>Kapoor</td>
                                    <td>kavitakapoor@bizbrolly.com</td>
                                    <td>
                                      <div className="d-flex">
                                        <a className="btn btn-secondary shadow btn-xs sharp me-1">
                                          <i className="fa fa-pencil"></i>
                                        </a>
                                        <a className="btn btn-danger shadow btn-xs sharp me-1">
                                          <i className="fa fa-trash"></i>
                                        </a>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <span className="name">Mk</span>{" "}
                                    </td>
                                    <td>
                                      <a href="">Mukesh</a>
                                    </td>
                                    <td>Kumar</td>
                                    <td>mukesh@bizbrolly.com</td>
                                    <td>
                                      <div className="d-flex">
                                        <a className="btn btn-secondary shadow btn-xs sharp me-1">
                                          <i className="fa fa-pencil"></i>
                                        </a>
                                        <a className="btn btn-danger shadow btn-xs sharp me-1">
                                          <i className="fa fa-trash"></i>
                                        </a>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <span className="name">GV</span>{" "}
                                    </td>
                                    <td>
                                      <a href="">Geeta</a>
                                    </td>
                                    <td>Sharma</td>
                                    <td>geetasharma@bizbrolly.com</td>
                                    <td>
                                      <div className="d-flex">
                                        <a className="btn btn-secondary shadow btn-xs sharp me-1">
                                          <i className="fa fa-pencil"></i>
                                        </a>
                                        <a className="btn btn-danger shadow btn-xs sharp me-1">
                                          <i className="fa fa-trash"></i>
                                        </a>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <span className="name">AV</span>{" "}
                                    </td>
                                    <td>
                                      <a href="">Aman</a>
                                    </td>
                                    <td>Verma</td>
                                    <td>aman@bizbrolly.com</td>
                                    <td>
                                      <div className="d-flex">
                                        <a className="btn btn-secondary shadow btn-xs sharp me-1">
                                          <i className="fa fa-pencil"></i>
                                        </a>
                                        <a className="btn btn-danger shadow btn-xs sharp me-1">
                                          <i className="fa fa-trash"></i>
                                        </a>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ManageUser;
